import { useLayoutEffect, useState } from "react";
import { getTicketsFit } from "./fitLayout";

export default function useTicketsFit(containerRef) {
  const [fit, setFit] = useState(() => getTicketsFit(0, 0));

  useLayoutEffect(() => {
    const element = containerRef.current;
    if (!element) return undefined;
    let frame;
    const pointer = window.matchMedia("(hover: hover) and (pointer: fine)");
    const measure = () => {
      const style = window.getComputedStyle(element);
      const width = element.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
      const height = element.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);
      const allowScale = Boolean(pointer.matches && window.CSS?.supports?.("zoom", "0.9"));
      const next = getTicketsFit(width, height, allowScale);
      setFit(previous => previous.scale === next.scale && previous.maxListWidth === next.maxListWidth
        ? previous : next);
    };
    const scheduleMeasure = () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(measure);
    };
    const observer = typeof ResizeObserver !== "undefined" ? new ResizeObserver(scheduleMeasure) : null;
    if (observer) observer.observe(element);
    window.addEventListener("resize", scheduleMeasure);
    pointer.addListener(scheduleMeasure);
    measure();
    return () => {
      if (observer) observer.disconnect();
      window.cancelAnimationFrame(frame);
      window.removeEventListener("resize", scheduleMeasure);
      pointer.removeListener(scheduleMeasure);
    };
  }, [containerRef]);

  return fit;
}
